module.exports = "<div class=\"container\">\r\n    <nav mat-tab-nav-bar>\r\n        <a mat-tab-link\r\n            *ngFor=\"let route of routes\"\r\n            [routerLink]=\"route.path\"\r\n            routerLinkActive #rla=\"routerLinkActive\"\r\n            [routerLinkActiveOptions]=\"{exact: true}\"\r\n            [active]=\"rla.isActive\">\r\n           {{route.label}}\r\n         </a>\r\n    </nav>\r\n    <router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main